import Common from "./common";

const Signup = () => {
  return (
    <>
      <Common signup />
    </>
  );
};

export default Signup;
